var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/ApplicationConstants.js');
var ApplicationsAPI = require('../apis/ApplicationsAPI.js');
var CommonAPI = require('../apis/CommonAPI.js');
var AddressAPI = require('../apis/AddressAPI.js');
var FundingYourProductAPI = require('../apis/FundingYourProductAPI.js');
var AdviceFeeAPI = require('../apis/AdviceFeeAPI.js');
var ProductsAPI = require('../apis/ProductsAPI.js');
var ClientsAPI = require('../apis/ClientsAPI.js');
var ActionTypes = Constants.ActionTypes;
var InvestmentAllocationAPI = require('../apis/InvestmentAllocationAPI.js');
var AccountTypeAPI = require('../apis/AccountTypeAPI.js');
var DownloadsAPI = require('../apis/DownloadsAPI.js');
var Products = require('../utils/Products.js');
var Message = require('../constants/InvestmentAllocationConstants.js').ApiResponseMessage;
module.exports = {
    navigateToAcquisition: function(){
        window.location =`${window.NOA.configuration.acquisitionSuperUrl}?adobe_mc=${encodeURIComponent(window.NOA.adobe_mc)}`;
    },
    showErrorBar: function(errorBarShown) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SHOW_ERROR_BAR,
            errorBarShown: errorBarShown
        });
    },
    agreeIDVerificationForm: function (agreeIDVerificationForm) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.AGREE_IDVERIFICATION_FORM,
            agreeIDVerificationForm: agreeIDVerificationForm
        });
    },
    saveWorkItem: function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SAVE_WORKITEM
        });
    },
    updateVerificationDocument: function (idVerificationModel) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_VERIFICATOIN_DOCUMENT,
            data: idVerificationModel
        });
    },
    clearErrorList: function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLEAR_ERROR_LIST
        });
    },
    saveApplication: function(productId, formModel, clientIdentificationMode) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SAVE_STARTING
        });
        ApplicationsAPI.saveApplication(productId, formModel, clientIdentificationMode);
        this.updateIsSaveDisabled(false);
    },
    gotoFieldWithError: function(data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GOTO_FIELD_WITH_ERROR,
            data: data
        });
    },
    setProductId: function(productId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_PRODUCT_ID,
            productId: productId
        });
    },
    createNewApplication: function(productId, clientOin) {
        if (window.NOA.userContext.isAdviser) {
            var selectMessage = Products.isInvestment(productId) ? Message.SELECT_MODEL_PORTFOLIO : Message.SELECT_PORTFOLIO;
            var noPortfolioMessage = Products.isInvestment(productId) ? Message.NO_MODEL_PORTFOLIO_SETUP : Message.NO_PORTFOLIO_SETUP;

            InvestmentAllocationAPI.getModelPortfolioList(productId, selectMessage, noPortfolioMessage);
        }

        //setting of product
        if (productId) {
            //only execute get investment options if the product is not annuities
            if (!Products.isAnnuity(productId)) {
                InvestmentAllocationAPI.getInvestmentOptionList(productId);
            }
            AccountTypeAPI.getAccountType(productId);
            AppDispatcher.dispatch({
                actionType: ActionTypes.NEW_APPLICATION_INITIALISED,
                productId: productId,
                clientOin: clientOin
            });

        }

        if (window.NOA.userContext.adviserCode && window.NOA.userContext.dealerCode) {
            AdviceFeeAPI.checkAdviserFeeFlag();
        }

        FundingYourProductAPI.getSuperFundList(productId);
        if (window.NOA.userContext.oin) {
            if (clientOin) {
                ClientsAPI.getClientAccountDetails(productId, clientOin, false);
            }
            if (window.NOA.userContext.userType === Constants.UserTypes.INVESTOR) {
                ClientsAPI.getBankAccountDetails(productId);
            }
        }
    },

    startApplicationRetrieve: function(applicationId, productId) {
        //spinner is to be displayed during retrieving 
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_RETRIEVE_STARTING
        });

        ApplicationsAPI.retrieveApplication(applicationId, productId);
    },

    requestApplicationSave: function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SAVE_REQUEST
        });
    },

    requestApplicationReview: function (withShellAccount) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_REVIEW_REQUEST,
            withShellAccount: withShellAccount
        });
    },

    validateApplication: function(productId, accountType) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.VALIDATE_APPLICATION,
            productId: productId,
            accountType: accountType
        });
    },

    validateApplicationSave: function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SAVE_VALIDATE
        });
    },

    sendInvestmentOptions: function(investmentOptionList) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_INVESTMENT_OPTIONS,
            investmentOptionList: investmentOptionList
        });
    },

    reviewApplication: function(data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.REVIEW_APPLICATION,
            formModel: data.formModel,
            consolidatedFormModel: data.consolidatedFormModel,
            sectionVisibility: data.sectionVisibility,
            product: data.product
        });
    },

    sendYourDetailsDob: function(dob) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_YOUR_DETAIL_DOB,
            dob: dob
        });
    },

    sendFundingAmount: function(balance) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_FUNDING_AMOUNT,
            balance: balance
        });
    },

    isFundingSummary: function(summary) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.IS_FUNDING_SUMMARY,
            summary: summary
        });
    },

    sendRipAnswer: function(answer) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_RIP_ANSWER,
            answer: answer
        });
    },

    sendIsSuperFirstTransfer: function(value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_IS_SUPER_FIRST_TRANSFER,
            value: value
        });
    },

    sendInSpecieDecisions: function(data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_INSPECIE_DECISIONS,
            data: data
        })
    },

    sendInSpecieData: function(data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_INSPECIE_DATA,
            data: data
        })
    },

    setPensionTypeSelected: function (selectedPensionType) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.IS_PENSION_TYPE_SELECTED,
            selectedPensionType: selectedPensionType
        })
    },
    setAssetAllocations: function(productId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_ASSET_ALLOCATIONS,
            productId: productId
        });
    },

    showMoreMenu: function(data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SHOW_MORE_MENU,
            showMoreMenu: data
        });
    },
    getIsProductRegistered: function(productId) {
        ProductsAPI.getIsProductRegistered(productId);
    },
    editSection: function(section) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.EDIT_SECTION,
            section: section
        });
    },
    isPreRetirement: function(value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.IS_PRE_RETIREMENT,
            value: value
        });
    },
    getAnnuityQuoteUrl: function(productId, accountNumber) {
        ProductsAPI.getAnnuityQuoteUrl(productId, accountNumber);
    },
    sendBankAccountFromRip: function(formError, model) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_BANK_ACCOUNT_FROM_RIP,
            formError: formError,
            model: model
        });
    },
    abortApiRequests: function() {
        AddressAPI.abort();
    },
    sendPortfolioRebateDetails: function(portfolioRebateData) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_PORTFOLIO_REBATE_DETAILS,
            portfolioRebateData: portfolioRebateData
        });
    },
    sendPensionPaymentDrawDownOption: function(drawDownOption) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_PENSION_PAYMENT_DRAW_DOWN_OPTION,
            drawDownOption: drawDownOption
        });
    },
    sendRipModel: function(ripModel) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_RIP_MODEL,
            model: ripModel
        });
    },
    sendEligibleContributionFromRip: function(contributions) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_ELIGIBLE_CONTRIBUTION_FROM_RIP,
            contributions: contributions
        });
    },
    sendPensionTypeOptions: function(options) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_PENSION_TYPE_OPTIONS,
            pensionTypeOptions: options
        });
    },
    sendShowRipSection: function(showRipSection) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_SHOW_RIP_SECTION,
            showRipSection: showRipSection
        });
    },
    showDownloadMenu: function(data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SHOW_DOWNLOAD_MENU,
            showDownloadMenu: data
        });
    },

    prepareFormsToDownload: function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.PREPARE_FORMS_TO_DOWNLOAD
        });
    },

    requestApplicationDownload: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_DOWNLOAD_REQUEST
        });
    },

    downloadForms: function (selectedForms, product, formModel) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.START_DOWNLOADING_FORMS
        });
        DownloadsAPI.downloadForms(selectedForms, product, formModel);
    },

    updateFormsToDownload: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_FORMS_TO_DOWNLOAD,
            index: data.index,
            checked: data.checked
        });
    },

    updateIsSaveDisabled: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_IS_SAVE_DISABLED,
            data: data
        });
    },

    clearDownloadedForms: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLEAR_DOWNLOADED_FORMS
        });
    },

    toggleShellAccountNotification: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_SHELL_ACCOUNT_NOTIFICATION
        });
    },

    toggleSaveApplicationNotification: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_SAVE_APPLICATION_NOTIFICATION
        });
    },

    submitApplication: function (productId, formModel, consolidatedInvestmentOptions) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SUBMIT_STARTING
        });
        ApplicationsAPI.submitApplication(productId, formModel, consolidatedInvestmentOptions);
    },

    getDigitalConsentKillSwitch: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DIGITALCONSENT_KILLSWITCH_STARTING
        });
        CommonAPI.getKillSwitch(Constants.KillSwitches.DIGITAL_CONSENT);
    },

    getAsfFeeKillSwitch: function(){        
        CommonAPI.getAsfFeeKillSwitch(Constants.KillSwitches.ASF_FORM);
    },

    getAsfCongratulationsPageKillSwitch: function(){        
        CommonAPI.getAsfCongratulationsPageKillSwitch(Constants.KillSwitches.ASF_CONGRATULATIONS_PAGE);
    },

    getCongratulationsPageDocumentKillSwitch: function(){        
        CommonAPI.getCongratulationsPageDocumentKillSwitch(Constants.KillSwitches.CONGRATULATIONS_PAGE_DOCUMENT);
    },

    transitionCompleted: function (destination) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TRANSITION_COMPLETED,
            destination: destination
        });
    },

    extendSession: function (extend) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.EXTEND_SESSION,
            extend: extend
        });
    },

    onContinueSession: function () {
        CommonAPI.extendSessionTimeout();
    },

    toggleApplicationSubmitErrorNotification: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TOGGLE_OFFLINE_APPLICATION_NOTIFICATION
        });
    },
    handleApplicationSubmitErrorNotification: function(errorCode) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OFFLINE_APPLICATION_NOTIFICATION,
            errorCode: errorCode
        });
    },
    sendIsManagedAccount: function(isManagedAccount) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_IS_MANAGED_ACCOUNT,
            isManagedAccount: isManagedAccount
        });
    },
     sendIsAdviserAuthorised: function (isAdviserAuthorised) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_IS_ADVISER_AUTHORISED,
            isAdviserAuthorised: isAdviserAuthorised
        });
    },
    getClientIdentificationMode: function (queryInfo) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_IDENTIFICATION_MODE_START_LOADING_IN_APPLICATION_FORM
        });
        ApplicationsAPI.getClientIdentificationMode(queryInfo);
    },
    getDownsizerContributionKillSwitch: function(){      
        CommonAPI.getDownsizerContributionKillSwitch(Constants.KillSwitches.DOWNSIZER_CONTRIBUTION);
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ApplicationActions.js